// Google API functions
import axios from "axios";

const api = axios.create({
  baseURL: "/api/google_del_api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

export const loadAddressSuggestions = async (
  inputValue,
  googleSessionToken
) => {
  // Only fetch suggestions if input is 4 or more characters
  if (!inputValue || inputValue.trim().length < 4) return Promise.resolve([]);

  try {
    const response = await api.get(
      `/site_address?input=${encodeURIComponent(
        inputValue
      )}&session_token=${googleSessionToken}`
    );
    return response.data;
  } catch (error) {
    console.error("Address suggestions error:", error);
    return Promise.resolve([]);
  }
};

// Get site details in order to formatt the address and get the location inforamtion for the nearby hospital search, also we need to use this to terminate the session token and not get billed for unused requests.
export const getSiteDetails = async (placeId, googleSessionToken) => {
  try {
    const response = await api.get(
      `/site_details?place_id=${placeId}&session_token=${googleSessionToken}`
    );
    console.log(response);
    return response.data;
  } catch (error) {
    console.error("Site details error:", error);
    return Promise.resolve([]);
  }
};

/**
 * Find nearby emergency medical facilities, ranked nearest-first
 * (hospitals, then urgent cares). Returns an array of options; [] on failure.
 * @param {number} lat
 * @param {number} lng
 * @returns {Promise<Array<{displayName: string, formattedAddress: string, type: string, distanceMiles: number|null}>>}
 */
export const findNearestHospital = async (lat, lng) => {
  try {
    const response = await api.get(`/nearest_hospital?lat=${lat}&lng=${lng}`);
    return response.data?.options || [];
  } catch (error) {
    console.error("Hospital search error:", error);
    return [];
  }
};

export const cacheAddress = async (addressData) => {
  try {
    const response = await api.post("/cache_address", addressData);
    return response.data;
  } catch (error) {
    console.error("Address caching error:", error);
    return null;
  }
};

/**
 * Reverse geocode coordinates to a street address.
 * Returns null silently on failure (offline-safe).
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {Promise<string|null>} Formatted address or null
 */
export const reverseGeocode = async (lat, lng) => {
  try {
    const response = await api.get(`/reverse_geocode?lat=${lat}&lng=${lng}`);
    return response.data?.address || null;
  } catch (error) {
    // Silently skip - address stays null (offline scenario)
    return null;
  }
};
